import React from 'react';

import { useLocation, Link } from 'react-router-dom'
import domain from 'src/config/domain';

function GroupMenu({ items, title, titleOnly }) {
  const { pathname } = useLocation();
  const domainConfig = domain();

  const baseClass = `text-lg pt-2 pb-[8px] mr-4 inline-flex items-center gap-x-2 border-b-2 text-sm whitespace-nowrap ${domainConfig.styles.textColour} hover:${domainConfig.styles.textColour} disabled:opacity-50 disabled:pointer-events-none text-sm`;
  const inaCtiveClass = `${baseClass} font-extalight border-transparent`;
  const activeClass = `${baseClass} font-extrabold ${domainConfig.styles.borderColour}`;

  // Helper function to check if a path matches a pattern with parameters
  const matchesPathPattern = (pattern, actualPath) => {
    if (!pattern) return false;
    
    // Convert pattern like '/payment-links/:id' to regex
    const regexPattern = pattern
      .replace(/:[^/]+/g, '[^/]+') // Replace :param with regex for non-slash characters
      .replace(/\//g, '\\/'); // Escape forward slashes

    const regex = new RegExp(`^${regexPattern}$`);
    const test = regex.test(actualPath);

    return test;
  };

  // Helper function to check if an item is active
  const isItemActive = (item) => {
    return item?.path === pathname || matchesPathPattern(item?.path, pathname);
  };

  let activeItem = null;
  let count = 0;
  let availableItems = 0;
  let activeTitle = null;

  for (const item of items) {
    if (item.check && (item.visible === undefined || item.visible === true)) {
      count += 1;
    }
    
    // Check for exact match first, then pattern match
    if (isItemActive(item)) {
      activeItem = item;
    }

    if ((item.check === true || typeof item.check === 'undefined') && (item.visible === undefined || item.visible === true)) {
      availableItems += 1;
    }

    if (item.check && isItemActive(item)) {
      activeTitle = item;
    }
  }

  // If no direct match found, check parent items
  if (activeItem === null) {
    for (const item of items) {
      if (item.parent) {
        // Check if pathname starts with the item path or matches the pattern
        if (pathname.includes(item.path) || matchesPathPattern(item?.path, pathname)) {
          activeItem = item;
          activeTitle = item;
        }
      }
    }
  }

  if (availableItems === 0) {
    return (
      <div className={`border-l-4 pl-2 border-violet-800 ${!activeItem?.description ? 'mb-2' : ''}`}>
        <h2
          className={`text-3xl bg-violet-800 inline-block text-transparent bg-clip-text pb-1 font-light font-mono uppercase tracking-wide`}>
          {activeTitle?.name || title}
        </h2>
        {activeItem?.description && (
          <p className='-mt-1 text-sm text-violet-900 mb-4 font-mono'>{activeItem.description}</p>
        )}
      </div>
    );
  }

  return (
    <div className={`pt-4 border-b-2 ${domainConfig.styles.lightBorderColour} position-relative px-8 ${domainConfig.styles.lightBGColour} border-t`}>

      <div className={`border-l-4 pl-2 ${domainConfig.styles.borderColour} ${!activeItem?.description ? 'mb-2' : ''}`}>
        <h2
          className={`text-3xl ${domainConfig.styles.primaryColourDarker} inline-block text-transparent bg-clip-text pb-1 font-light font-mono uppercase tracking-wide`}>
          {activeTitle?.name || title}
        </h2>
        {activeItem?.description && (
          <p className={`-mt-1 text-sm ${domainConfig.styles.textColour} mb-4 font-mono`}>{activeItem.description}</p>
        )}
      </div>

      <nav id="page-tabs-bar" className={`mr-2 ${domainConfig.styles.lightBorderColour} ml-0.5 block lg:flex -mb-0.5 ${items.length === 0 || count < 2 ? 'pb-2' : ''} `}>
        {count > 1 && items.map((item, index) => {
          if (item.check && typeof item.visible === 'undefined') {
            return (
              <Link
                to={item.path}
                key={index}
                className="w-100 lg:w-auto block lg:inline-grid flex-1 flex-grow"
              >
                <button
                  type="button"
                  className={isItemActive(item) || activeItem?.parent === item?.name ? activeClass : inaCtiveClass}
                  id={`basic-tabs-item-${index + 1}`}
                  aria-controls={`basic-tabs-item-${index + 1}`}
                  role="tab"
                >
                  {item.name}
                </button>
              </Link>
            )
          }

          return <React.Fragment key={index} />
        })}

      </nav>
    </div>
  );
}
export default React.memo(GroupMenu);
